import { CoenergyUserRole, isPartnerRole } from '../types/CoenergyUserRole';

import { Paths } from './Paths';

export const getDefaultPathForRole = (role: CoenergyUserRole) => {
  if (isPartnerRole(role)) {
    return Paths.Partner;
  }

  if (role === CoenergyUserRole.Admin) {
    return Paths.AdminPartners;
  }

  return Paths.Home;
};
